import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle subscription expired responses globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const detail = error.response?.data?.detail;
    if (detail && typeof detail === 'object' && detail.code === 'subscription_expired') {
      // Dispatch custom event so dashboard can show overlay
      window.dispatchEvent(new CustomEvent('subscription-expired'));
    }
    return Promise.reject(error);
  }
);

export default api;
